import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Mailer extends CommonCRUD {}

export default Mailer;
